import { useDevice } from '@portalterreno/react-ui/DeviceProvider';
import Visible from '@portalterreno/react-ui/Visible';
import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import useRouter from '../../../hooks/useRouter';
import { setWhatsappOpened } from '../../../redux/slices/contactForm';
import { RootState } from '../../../redux/store';
import DesktopButton from './DesktopButton';
import MobileButton from './MobileButton';

export type WhatsappContactProps = {
  sellerWhatsapp: string;
  propertyId: number;
  onClickWhatsappButton: () => void;
};

const WhatsappContact: React.FC<WhatsappContactProps> = ({
  sellerWhatsapp,
  onClickWhatsappButton,
  ...rest
}) => {
  const dispatch = useDispatch();
  const { isMobile } = useDevice();
  const router = useRouter();

  const state = useSelector(
    (state: RootState) => ({
      status: state.contactForm.status,
      source: state.contactForm.source,
      isWhatsappFormSent: state.contactForm.isWhatsappFormSent,
      whatsappOpened: state.contactForm.whatsappOpened
    }),
    shallowEqual
  );

  const message = React.useMemo(() => {
    return `¡Hola! Quiero saber más sobre ${process.env.NEXT_PUBLIC_CANONICAL_HOST}${router.asPathWithoutParams}, publicado en PortalTerreno.

Contáctame, por favor.

¡Saludos!`;
  }, [router.asPathWithoutParams]);

  React.useEffect(() => {
    if (
      state.source === 'whatsapp' &&
      state.isWhatsappFormSent &&
      !state.whatsappOpened &&
      state.status === 'success'
    ) {
      dispatch(setWhatsappOpened(true));

      let url: string;
      const text = encodeURIComponent(message);
      const whatsapp = sellerWhatsapp.replace(/\D/g, '');

      if (isMobile) {
        url = `https://wa.me/${whatsapp}?text=${text}`;
      } else {
        url = `https://web.whatsapp.com/send?phone=${whatsapp}&text=${text}`;
      }

      const whatsappTab = window.open(url, '_blank');
      if (!whatsappTab) {
        if (isMobile) {
          url = `whatsapp://send?phone=${whatsapp}&text=${text}`;
        }
        window.open(url, '_top');
      }
    }
  }, [
    dispatch,
    message,
    state.status,
    sellerWhatsapp,
    state.isWhatsappFormSent,
    state.source,
    state.whatsappOpened,
    isMobile
  ]);

  return (
    <React.Fragment>
      <Visible desktop>
        <DesktopButton
          onClickWhatsappButton={onClickWhatsappButton}
          {...rest}
        />
      </Visible>
      <Visible mobile>
        <MobileButton
          onClickWhatsappButton={onClickWhatsappButton}
          {...rest}
        />
      </Visible>
    </React.Fragment>
  );
};

export default WhatsappContact;
